export const minLengthValidation = (minLength: number, message?: string) => ({
    validate: (val: string | undefined): true | string => {
        if (!val || val.length >= minLength) {
            return true;
        }
        return message || `Значение должно содержать не менее ${minLength} символов.`;
    }
});